import { search } from "../../../../BaseRepositoryComponents";
import { findProdutosAlternativeFlat } from "./formatters/ProdutoFormatters";

const path = `${process.env.REACT_APP_URL_API_ERP}/erp/estoque/produtos/v1`;
const token = process.env.REACT_APP_TOKEN_API_ERP;

const headers = new Headers();
headers.append("Authorization", token);
headers.append("content-type", "application/json");

export async function findProdutos({
  empresa_cnpj,
  id,
  include = "",
  page,
  where = {},
  orwhere = {},
  isSameOrWhere = false,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&where[${key}]=${where[key]}`;
  });

  let queryOrWhere = "";
  Object.keys(orwhere).forEach((key) => {
    queryOrWhere += `&orwhere${isSameOrWhere ? "[]" : ""}[${key}]=${
      orwhere[key]
    }`;
  });

  return search(
    `${path}${
      id ? `/${id}` : ""
    }?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      include ? `&include=${include}` : ""
    }${page ? `&page=${page}` : ""}`,
    "GET",
    headers
  );
}

export async function createProduto(empresa_cnpj, body) {
  return search(`${path}?empresa_cnpj=${empresa_cnpj}`, "POST", headers, body);
}

export async function updateProduto(id, empresa_cnpj, body) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "PUT",
    headers,
    body
  );
}

export function deleteProduto(id, empresa_cnpj) {
  return search(
    `${path}/${id}?empresa_cnpj=${empresa_cnpj}`,
    "DELETE",
    headers
  );
}

export async function itensNfAutoMontagem(
  empresa_cnpj,
  empresa_id,
  body,
  include = "",
  perPage = 100
) {
  const ids = "ids[]=" + body.ids.join("&ids[]=");

  return search(
    `${path}/nfautomontagem?empresa_cnpj=${empresa_cnpj}&empresa_id=${empresa_id}&${ids}${
      body?.orderBy ? `&orderBy=${body.orderBy}` : ""
    }${body?.tipoDocumento ? `&tipoDocumento=${body.tipoDocumento}` : ""}${
      body?.tipoDestinatario ? `&tipoDestinatario=${body.tipoDestinatario}` : ""
    }${include ? `&include=${include}` : ""}&per_page=${perPage}`,
    "GET",
    headers
  );
}

export async function findProdutosAlternativeFormatted({
  empresa_cnpj,
  page,
  where = {},
  include = "",
  orwhere = {},
  isSameOrWhere = false,
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&${key}=${where[key]}`;
  });

  let callback = await search(
    `${path}/porcodigobarrauniao?empresa_cnpj=${empresa_cnpj}${queryWhere}${
      page ? `&page=${page}` : ""
    }${include && `&include=${include}`}`,
    "GET",
    headers
  );

  if (callback.success) {
    callback = {
      ...callback,
      data: findProdutosAlternativeFlat(callback.data),
    };
  }

  return callback;
}

export async function findProdutosAlternativeRaw({
  empresa_cnpj,
  page,
  where = {},
  orwhere = {},
  isSameOrWhere = false,
  include = "",
}) {
  let queryWhere = "";
  Object.keys(where).forEach((key) => {
    queryWhere += `&${key}=${where[key]}`;
  });

  return search(
    `${path}/porcodigobarrauniao?empresa_cnpj=${empresa_cnpj}${queryWhere}${
      page ? `&page=${page}` : ""
    }${include && `&include=${include}`}`,
    "GET",
    headers
  );
}

export async function getScaleFile({
  empresa_cnpj,
  stockLocation = "",
  priceTable = "",
  where = {},
  orwhere = {},
}) {
  let queryOrWhere = "";
  if (orwhere) {
    Object.keys(orwhere).forEach((key) => {
      queryOrWhere += `&orwhere[${key}]=${orwhere[key]}`;
    });
  }

  let queryWhere = "";
  if (where) {
    Object.keys(where).forEach((key) => {
      queryWhere += `&where[${key}]=${where[key]}`;
    });
  }

  return search(
    `${path}/arquivobalanca?empresa_cnpj=${empresa_cnpj}${queryWhere}${queryOrWhere}${
      stockLocation && `&stockLocation=${stockLocation}`
    }${priceTable && `&priceTable=${priceTable}`}`,
    "GET",
    headers
  );
}

export async function findProductByDescription({ empresa_cnpj, description }) {
  return search(
    `${path}?empresa_cnpj=${empresa_cnpj}&where[%"descricao"%]=${description}`,
    "GET",
    headers
  );
}
